<template>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1"/>
    <title>Receipt</title>
    <link rel="shortcut icon" href="images/favicon.png" type="image/x-icon"/>
    <link rel="preconnect" href="https://fonts.googleapis.com"/>
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
    <link
        href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
        rel="stylesheet"
    />
    <link rel="preconnect" href="https://fonts.googleapis.com"/>
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
    <link
        href="https://fonts.googleapis.com/css2?family=Yellowtail&display=swap"
        rel="stylesheet"
    />
  </head>

  <!--@contextmenu.prevent-->
  <body
      style="
        padding: 0px;
        margin: 0px;
        font-family: 'Montserrat', sans-serif;
        background-color: #a2a2a21c;
        box-sizing: border-box;">


  <button class="print-btn" onclick="window.print()">
    <img :src="'./assets/printer.svg'" alt="Printer Icon"/>
  </button>

  <button class="print-btn email-doc" title="send On Email"><img :src="'./assets/email-icon.png'" alt="Printer Icon ">
  </button>

  <page
      class="page"
      style="
          width: 210mm;
          height: 297mm;
          display: flex;
          position: relative;
          flex-flow: column;
          background-color: white;
        "
  >


    <!-- main content -->
    <div style="padding: 8.5mm">
      <header
          style="
              display: flex;
              height: 47mm;
              align-items: center;
              position: relative;
              width: 100%;
              justify-content: space-between;
            "
      >
        <div>
          <img
              :src="county.stateLogo"
              style="height: 36mm; margin-right: 0mm"
          />
        </div>
        <div style="text-align: center; margin-right: 8.5mm; margin-left: 8.5mm;">
          <h2
              style="
                  margin-top: 0px;
                  font-size: 26px;
                  text-transform: uppercase;
                  color: #4ca82c;
                  font-weight: 700;
                  margin-bottom: 1.2mm;
                  padding-bottom: 0px;
                "
          >
            County Government<br>Of {{county.countyName}}
          </h2>

          <h5 style="
              padding: 0px;
              margin: 0px;
              font-size: 18px;
              font-weight: bold;
              text-transform: uppercase;
              margin-bottom: 4.5mm;
            ">
            ({{receiptDetails.subCountyName}} {{receiptDetails.wardName}} {{receiptDetails.zone}})
          </h5>

          <h4
              style="
                  padding: 0px;
                  margin: 0px;
                  font-size: 14px;
                  font-weight: 400;
                "
          >
            {{county.address}}<br>
            Email: {{county.email}}
          </h4>

          <h4 style="
              padding: 0px;
              margin: 0px;
              font-size: 13px;
              font-weight: 400;
              font-style: italic;
              font-family: 'Times New Roman', Times, serif;
              margin-top: 2mm;
            ">
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif; margin-right: 3mm;">{{county.headline}}</span>
            <span style="font-style: italic; font-family: 'Times New Roman', Times, serif;">{{county.tagline2}}</span>
          </h4>
        </div>
        <div>
          <img
              :src="county.logo"
              style="height: 36mm; margin-right: 0mm"
          />
        </div>
      </header>
      <div>
        <img :src="'./assets/blue-line.png'" style="width: 100%"/>
      </div>

      <!-- contact information and QR code -->
      <div style="display: flex; justify-content: space-between">
        <!-- contact information -->
        <div style="font-size: 12px">
          <h2
              style="
                  margin-top: 0px;
                  font-size: 18px;
                  text-transform: uppercase;
                  color: #0045a1;
                  font-weight: 700;
                  margin-bottom: 3.3mm;
                  margin-top: 3.3mm;
                  padding-bottom: 0px;
                "
          >
            Receipt For {{ receiptDetails.incomeTypeDescription }}
          </h2>

          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm">
            Support Tel No: {{county.contact}}
          </p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm">
            Email:{{county.email}}
          </p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm">
            Office Line (Business Hours) {{county.contact}}
          </p>

          <p
              style="
                  padding: 0px;
                  margin: 0px;
                  padding-top: 4.3mm;
                  padding-bottom: 1.5mm;
                "
          >
            Payment Received From:
            <strong>{{ receiptDetails.paidBy }}</strong>
          </p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm">
            Receipt No. <strong>{{ receiptDetails.receiptNo }}</strong>

          </p>
          <p style="padding: 0px; margin: 0px; padding-top: 0mm; padding-bottom: 1.5mm">
            Printed On. <strong style="text-transform:uppercase;">{{getCurrentDateTime()}}</strong>
          </p>
        </div>

        <!-- the qr code -->
        <div
            style="
                height: 25.3mm;
                margin-top: 3.3mm;
                width: 25.3mm;
                border: 2px solid #0045a1;
                display: flex;
                justify-content: center;
                align-items: center;
              "
        >
          <img :src="link" style="height: 25mm"/>
        </div>
      </div>

      <!-- the table -->
      <small><strong style="">{{receiptDetails.description}}</strong></small>
      <!-- the table contents -->
      <table
          style="
              margin-top: 6.3mm;
              border-spacing: initial;
              display: block;
              min-height: 50mm;
            "
      >
        <thead
            class=""
            style="
                text-transform: uppercase;
                font-weight: 700;
                font-size: 12px;
                background: #e2f2fd;
                padding: 2.5mm;
              "
        >
        <tr>
          <td style="padding: 2.5mm">No.</td>
          <td style="padding: 2.5mm">Fee description</td>
          <td style="text-align: right; padding: 2.5mm; width: 50mm">
            Amount Paid
          </td>
        </tr>
        </thead>
        <tbody v-for="(item, index) in receiptInfos" :key="`item-${index}`" style="font-size: 12px">
        <tr>
          <td style="padding: 2.5mm; border-bottom: 1px solid #80808029;">
            {{ index + 1 }}.
          </td>
          <td style="padding: 2.5mm; border-bottom: 1px solid #80808029;">
            <p style="margin: 0px; padding: 0px;">{{ item.feeDescription}}</p>
            <strong style="">{{maskPhoneNumber(item.customer)}}</strong>
            <small>{{item.description}}</small>
          </td>
          <td style="text-align: right; padding: 2.5mm; border-bottom: 1px solid #80808029;">
            <strong>KES {{numberFormat(item.receiptAmount)}}</strong>
          </td>
        </tr>
        </tbody>
      </table>

      <div>
        <img
            :src="'./assets/blue-line.png'"
            style="width: 100%; margin-bottom: 4mm"
        />
      </div>

      <!-- billing details and summary -->

      <div
          class=""
          style="
              display: flex;
              text-transform: uppercase;
              justify-content: space-between;
            "
      >
        <div style="font-size: 12px">
          <h2
              style="
                  margin-top: 0px;
                  font-size: 18px;
                  text-transform: uppercase;
                  color: #0045a1;
                  font-weight: 700;
                  margin-bottom: 3.3mm;
                  margin-top: 3.3mm;
                  padding-bottom: 0px;
                  text-transform: uppercase;
                "
          >
            Billing & Payment Info
          </h2>

          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm">
            Paid via <strong>{{ receiptDetails.source }} #{{receiptDetails.transactionCode}}</strong>
          </p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm">
            Bill NO. <strong>{{receiptDetails.billNo}}</strong>
          </p>

          <p
              style="
                  padding: 0px;
                  margin: 0px;
                  padding-top: 4.3mm;
                  padding-bottom: 1.5mm;
                "
          >
            Billing Date: <strong>{{ formatDate(receiptDetails.dateCreated) }}</strong>
          </p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm">
            Payment date <strong>{{ formatDate(receiptDetails.dateCreated) }}</strong>
          </p>
        </div>

        <div>
          <table
              style="
                  margin-top: 3.3mm;
                  border-spacing: inherit;
                  text-transform: capitalize;
                  font-size: 14px;
                "
          >
            <tbody>
            <tr>
              <td
                  style="padding: 2.5mm; border-bottom: 1px solid #d9d9d9"
              >
                Amount Billed:
              </td>
              <td
                  style="
                        text-align: right;
                        padding: 2.5mm;
                        border-bottom: 1px solid #d9d9d9;
                      "
              >
                <strong>KES {{numberFormat(receiptDetails.detailAmount)}}</strong>
              </td>
            </tr>

            <tr>
              <td
                  style="padding: 2.5mm; border-bottom: 1px solid #d9d9d9"
              >
                Amount Paid:
              </td>
              <td
                  style="
                        text-align: right;
                        padding: 2.5mm;
                        border-bottom: 1px solid #d9d9d9;
                      "
              >
                <strong>KES {{numberFormat(receiptDetails.receiptAmount)}}</strong>
              </td>
            </tr>

            <tr>
              <td style="padding: 2.5mm">Balance:</td>
              <td style="text-align: right; padding: 2.5mm">
                <strong>KES {{numberFormat(receiptDetails.billBalance)}}</strong>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <!-- the footer starts here -->
    <div
        style="
            padding: 8.5mm;
            width: 100%;
            background-color: #e2f2fd;
            flex-grow: 1;
            margin-top: 2mm;
            display: flex;
            flex-flow: column;
            align-items: baseline;
            justify-content: space-between;
          "
    >
      <div
          style="display: flex; justify-content: space-between; width: 100%"
      >
        <div style="font-size: 12px; padding-top: 3.3mm">
          <h2
              style="
                  margin-top: 0px;
                  font-size: 18px;
                  text-transform: uppercase;
                  color: #0045a1;
                  font-weight: 700;
                  margin-bottom: 3.3mm;
                  padding-bottom: 0px;
                  text-transform: uppercase;
                "
          >
            County channels platforms
          </h2>

          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm">
            USSD Code:<strong>{{county.ussd}}</strong>
          </p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm">
            Self service portal: <strong>{{county.selfService}}</strong>
          </p>
          <p style="padding: 0px; margin: 0px; padding-bottom: 1.5mm">
            Mobile App: <strong>{{county.mobileApp}}</strong>
          </p>
        </div>

        <div style="padding-top: 3.3mm; padding-left: 17.3mm; display: none;">
          <div
              style="
                  display: flex;
                  margin-bottom: 4mm;
                  justify-content: center;
                  align-items: center;
                "
          >
            <img
                :src="'./assets/android-logo.svg'"
                style="margin-right: 3.3mm; height: 12mm"
            />
            <span
                style="
                    font-family: 'Yellowtail', cursive;
                    color: #0045a1;
                    line-height: 0.9;
                    font-size: 20px;
                  "
            >Scan to download the <br/>Android App.</span
            >
          </div>

          <div style="position: relative; display: flex">
            <img
                :src="'./assets/code-demo.png'"
                style="height: 16.6mm; margin: 1.25mm"
            />
            <img
                :src="'./assets/camera-frame.svg'"
                style="position: absolute; left: 0; height: 18.6mm"
            />

            <img
                :src="'./assets/curved-arrow.svg'"
                style="height: 13mm; margin-left: 4mm"
            />
          </div>
        </div>
      </div>

      <footer style="position: relative; width: 100%">
        <div style="position: absolute; bottom: 0mm">
          <div style="display: flex; flex-flow: column;">
                <span
                    style="
                    font-family: 'Yellowtail', cursive;
                    color: #0045a1;
                    line-height: 0.9;
                    font-size: 20px;
                    text-align: right;
                  "
                >Thank You!</span
                >
            <img :src="'./assets/blue-line.png'" style="width: 100%"/>
          </div>
          <div
              style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-top: 2mm;
                "
          >
            <p
                style="
                    padding-bottom: 10px;
                    margin-bottom: 0px;
                    font-size: 12px;
                    margin-top: 0mm;
                  "
            >
              Served By <strong>{{receiptDetails.names}}</strong> {{county.powered}}
            </p>
            <p style="padding-bottom:10px; margin-bottom:0px;font-size: 12px;margin-top: 0mm;">
              <strong>RECEIPT NO. {{receiptDetails.receiptNo}}</strong>
            </p>
            <div
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    margin-left: 8.5mm;
                    display: none;
                  "
            >
              <img
                  :src="county.poweredByLogo"
                  style="height: 10mm; padding-left: 2.5mm"
              />
            </div>
          </div>{{county.tagline2}}
        </div>
      </footer>
    </div>
  </page>
  </body>

</template>

<script>
/* eslint-disable */
import {execute, biller, authUrl} from "@/api";
import dayjs from 'dayjs';

export default {
  name: "printReceipt",
  data() {
    return {
      date: null,
      receiptDetails: {
        id: null,
        receiptNo: null,
        billNo: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        costCenterNo: null,
        accountNo: null,
        incomeTypeDescription: null,
        feeID: null,
        wardID: null,
        subCountyID: null,
        currency: null,
        source: null,
        transactionCode: null,
        paidBy: null,
        dateCreated: null,
        dateModified: null,
        createdBy: null,
        modifiedBy: null,
        isActive: null,
        status: null,
      },
      link: '',
      receiptInfos: [],
      county: {
        id: null,
        countyID: null,
        countyName: null,
        tagline: null,
        smsusername: null,
        smspassword: null,
        contact: null,
        center: null,
        address: null,
        email: null,
        headline: null,
        tagline2: null,
        ussd: null,
        logo: null,
        bank: null,
        powered: null,
        stateLogo: null,
        seal: null,
        signature: null,
        lat: null,
        lng: null,
        link: null,
        paysol: null,
        poweredByLogo: null,
        mobileApp: null,
        selfService: null,
        QRLink: null
      },
    };
  },
  mounted() {
    this.initializeData();
  },

  watch: {
    // Watch for route changes to handle navigation with different receipt numbers
    '$route.params.receiptNo': {
      handler(newReceiptNo) {
        if (newReceiptNo) {
          this.getReceipt(newReceiptNo);
        }
      },
      immediate: false
    }
  },

  methods: {

    async initializeData() {
      // First load county data
      await this.getCounty();
      // Then check URL params and load receipt
      this.checkUrlParams();
      this.menuAccess();
    },

    async getCounty() {
      try {
        const data = new FormData();
        data.append("function", "getCounty");
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.county = res.data.data.county;
        }
      } catch (e) {
        console.error(e);
      }
    },

    checkUrlParams() {
      // Check for route params first (e.g., /receipt/UAL0J4CEAD)
      const routeReceiptNo = this.$route.params.receiptNo;

      // Then check for query params (e.g., /receipt?receiptNo=UAL0J4CEAD)
      const urlParams = new URLSearchParams(window.location.search);
      const queryReceiptNo = urlParams.get('receiptNo') || urlParams.get('transactionCode');

      // Then check localStorage as fallback
      let localStorageReceiptNo = null;
      try {
        const params = JSON.parse(localStorage['params']);
        localStorageReceiptNo = params.receiptNo;
      } catch (error) {
        // ignore
      }

      // Route params take priority, then query params, then localStorage
      const receiptNo = routeReceiptNo || queryReceiptNo || localStorageReceiptNo;

      if (receiptNo) {
        console.log('####' + receiptNo);
        this.getReceipt(receiptNo);
      }
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length === 10) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input;
    },

    menuAccess(){

      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Print Receipt");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then(() => {
            // alert(res.data.message);
          })
          .catch(() => {
            // alert(e.message);
          });

    },

    getCurrentDateTime() {
      const now = new Date();
      const formattedDateTime = now.toLocaleString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      });
      return formattedDateTime;
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },

    formatDate(dateString) {
      const date = dayjs(dateString, 'YYYY-MM-DD HH:mm:ss');
      return date.format('DD MMM YYYY [AT] hh:mm A');
    },

    showDate() {
      const dateObj = new Date();
      const currentDate =
          dateObj.getDate() +
          "/" +
          (dateObj.getMonth() + 1) +
          "/" +
          dateObj.getFullYear();
      return currentDate;
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    getReceipt(receiptNo) {
      const data = new FormData();
      data.append("function", "getReceipt");
      data.append("receiptNo", receiptNo);


      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.receiptDetails = res.data.data.receiptDetails;
              this.receiptInfos = res.data.data.receiptInfos;
              this.county = res.data.data.county;

              // Generate QR code linking to receipt page using selfService URL
              const baseUrl = this.county.selfService || window.location.origin;
              const qrBaseUrl = this.county.QRLink || 'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=';
              const receiptUrl = baseUrl + '/#/receipt/' + this.receiptDetails.receiptNo;
              this.link = qrBaseUrl + encodeURIComponent(receiptUrl);

            } else {
              alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
  -webkit-print-color-adjust: exact !important;
  /* Chrome, Safari */
  color-adjust: exact !important;
  /*Firefox*/
}

.print-btn {
  display: flex;
  z-index: 1000000000;
  position: fixed;
  background: #4aaa23;
  color: white;
  top: 30px;
  right: 30px;
  border-radius: 50%;
  padding: 1rem;
  margin: 0px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 0px 20px 4px rgb(136 136 136 / 65%);
  cursor: pointer;
  transition: 0.4s;
}

.print-btn img {
  height: 35px;
}

.email-doc {
  top: 130px;
  background: #146fc5;
}

@media print {
  .print-btn {
    display: none;
  }

  body {
    margin: 0px !important;
    padding: 0px !important;
  }

  @page {
    /* size: auto; */
    /* auto is the initial value */
    /* this affects the margin in the printer settings */
    /* width: 210mm;*/
    /* height: 297mm; */
    size: A4 portrait;
    margin: 0px;
    margin-bottom: 0px;
    margin: 0px;
  }
}

@page {
  /* size: auto; */
  /* auto is the initial value */
  /* this affects the margin in the printer settings */
  /* width: 210mm;
    height: 297mm; */
  size: A4 portrait;
  margin: 0px;
  margin-bottom: 0px;
  margin: 0px;
}
</style>